import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Typography, useMediaQuery } from '@material-ui/core';

import SwiperCarousel, { SwiperSlide } from '@/components/Carousels/SwiperCarousel';

// HELP
import Question from './help/Question';

// STYLES
import { Container } from './styles';

const Questions = () => {
  const [t] = useTranslation();
  const { partner } = useSelector(({ partner: partnerState }) => ({
    partner: partnerState.data || {},
  }));
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const textOverwrites = partner.text_overwrites || {};

  const options = {
    navigation: false,
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        spaceBetween: 16,
      },
      600: {
        slidesPerView: 1.5,
        spaceBetween: 30,
      },
      960: {
        slidesPerView: 2.1,
        spaceBetween: 30,
      },
    },
  };

  const questionsData = [
    {
      question:
        textOverwrites.streamtv_question1_question ||
        t('partnerStreamTV.questions.question1.question'),
      answer:
        textOverwrites.streamtv_question1_answer || t('partnerStreamTV.questions.question1.answer'),
    },
    {
      question:
        textOverwrites.streamtv_question2_question ||
        t('partnerStreamTV.questions.question2.question'),
      answer:
        textOverwrites.streamtv_question2_answer || t('partnerStreamTV.questions.question2.answer'),
    },
    {
      question:
        textOverwrites.streamtv_question3_question ||
        t('partnerStreamTV.questions.question3.question'),
      answer:
        textOverwrites.streamtv_question3_answer || t('partnerStreamTV.questions.question3.answer'),
    },
    {
      question:
        textOverwrites.streamtv_question4_question ||
        t('partnerStreamTV.questions.question4.question'),
      answer:
        textOverwrites.streamtv_question4_answer || t('partnerStreamTV.questions.question4.answer'),
    },
  ];

  return (
    <Container className="section section--dark questions">
      <div className="page-content">
        <Typography className="text-bold m-b-10" component="h2" variant={downXs ? 'h4' : 'h2'}>
          {t('partnerStreamTV.questions.title')}
        </Typography>
        <Typography className="m-b-40" variant="subtitle2">
          {t('partnerStreamTV.questions.subtitle')}
        </Typography>
        <SwiperCarousel options={options}>
          {questionsData.map((item, index) => (
            <SwiperSlide key={index}>
              <Question data={item} />
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      </div>
    </Container>
  );
};

export default React.memo(Questions);
